import { TruncationSlopeType } from "building-types/settings/roofBaseTypes";
import type { NeighborRoofs, RoofTruncationOptions } from "building-types/settings/roofTypes";
import { evalFormulaAsNumber } from "doc/formula/formulaEval";
import { isFormula } from "doc/formula/formulaParsing";
import { DIST_EPSILON } from "geom/core";

function getLastNeighborSlope(
  neighbor: { readonly slopes: readonly { slope: number }[] } | undefined,
): number | undefined {
  if (!neighbor || neighbor.slopes.length === 0) {
    return undefined;
  }
  return neighbor.slopes[neighbor.slopes.length - 1].slope;
}

function evalFirstSlopeOptionSlope(truncation: RoofTruncationOptions): number | undefined {
  const first = truncation.slopeOptions[0];
  if (!first) {
    return undefined;
  }
  return isFormula(first.slope) ? evalFormulaAsNumber(first.slope) : first.slope;
}

export function resolvedTruncationHipSideSlopeForFraming(
  truncation: RoofTruncationOptions,
  neighborRoofs: NeighborRoofs,
  isStartTruncation: boolean,
): number | undefined {
  const slopeType = truncation.slopeType;

  if (slopeType === TruncationSlopeType.OVERRIDE) {
    return evalFirstSlopeOptionSlope(truncation);
  }

  if (slopeType === TruncationSlopeType.FROM_HOST) {
    const hostNeighbor = isStartTruncation ? neighborRoofs.endNeighbor : neighborRoofs.startNeighbor;
    const fallbackNeighbor = isStartTruncation ? neighborRoofs.startNeighbor : neighborRoofs.endNeighbor;
    const primary = getLastNeighborSlope(hostNeighbor);
    const fallback = getLastNeighborSlope(fallbackNeighbor);
    const slope = primary ?? fallback;
    if (slope !== undefined && Math.abs(slope) > DIST_EPSILON) {
      return slope;
    }
    return undefined;
  }

  return undefined;
}
